import React from 'react'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
// core components
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import Timeline from 'components/Timeline/Timeline.js'

import styles from 'assets/jss/material-kit-react/views/companySections/historyStyle.js'

const useStyles = makeStyles(styles)

export default function HistorySection() {
  const classes = useStyles()

  // 公司发展历程数据
  const historyData = [
    {
      date: '2017',
      title: '公司成立',
      content: [
        {
          text: '9月 | 江苏硕佰建筑科技有限公司成立',
          supplement: '配合省市各级政府提供绿色建筑、既有建筑节能改造、绿色生态城区等技术咨询服务',
        },
      ],
    },
    {
      date: '2018',
      title: '重要里程碑',
      content: [
        {
          text: '8月 | 协助如皋市成功获批省级绿色建筑示范城市提供申报、创建、验收的全过程绿色低碳服务',
          supplement:
            '服务内容主要包括协助示范申报、实施方案编制、区域绿色生态系统专项规划编制、创建期三年内的示范项目管理、技术审查指导、过程监管配合、验收评估服务等',
        },
        {
          text: '11月 | 成立中共江苏硕佰建筑科技有限公司党支部',
          supplement: '',
        },
      ],
    },
    {
      date: '2019',
      title: '业务拓展',
      content: [
        {
          text: '1月 | 新增地产板块业务',
          supplement: '为地产开发新建项目(住宅、文旅、商业综合体等)提供绿色建筑、超低能耗建筑、BIM等咨询服务',
        },
        {
          text: '10月 | 设立南通区域分公司，提供区域属地化服务',
          supplement: '',
        },
      ],
    },
    {
      date: '2020',
      title: '深化合作与扩张',
      content: [
        {
          text:
            '1月 | 与省市机关事务管理局建立长期合作为各级机关提供节能改造相关技术服务(如节能改造方案、能源审计、节能量核定、示范创建等)',
          supplement:
            '江苏省政协/省委统战部/民宗委/公安厅/生态环境厅等省级机关南京市委及各区机关/连云港/盐城市及大丰区/扬州/徐州/南通/宿迁等',
        },
        {
          text: '12月 | 在合肥设立安徽子公司(安徽硕万)。次年成为安徽省建筑节能与科技协会理事单位',
          supplement: '',
        },
      ],
    },
    {
      date: '2024',
      title: '能源科技新篇章',
      content: [
        {
          text: '8月 | <a href="https://www.king-sure.com/" target="_blank" rel="noopener noreferrer">江苏金硕智创能源科技有限公司</a>成立',
          supplement: '聚焦工商业能源动力系统节能降碳改造、光储充-体化建设等领域，提供综合能碳一站式服务解决方案(诊断-设计-投资-建设-运维)',
        },
      ],
    },
    {
      date: '2025',
      title: '战略合作',
      content: [
        {
          text: '6月 | 与央国企建立战略合作关系共建上海绿色产业服务中心隶属上海现代服务业联合会',
          supplement: '牵头单位包括上海电气集团+上海仪电集团(智算)+绿地金创(碳资产开发/交易)+联合赤道(ESG评级披露)+江苏银行(绿色金融)等',
        },
        {
          text: '9月 | 与中宣部下属国家智库平台签署重大项目合作共建协议',
          supplement: '与国家城乡统筹发展研究中心签署战略合作协议，聚焦白酒和医疗行业的综合能碳技术服务，在全国范围推广“金硕经验”',
        },
      ],
    },
  ]

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <div className={classes.titleWrapper}>
              <h2 className={classes.title}>发展历程</h2>
              <h4 className={classes.description}>
                从2017年成立至今，硕佰建筑科技始终秉承绿色发展理念， 在绿色建筑、节能改造、综合能源等领域不断创新发展，
                为推动建筑行业绿色转型贡献力量。
              </h4>
            </div>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <Timeline items={historyData} color="primary" />
          </GridItem>
        </GridContainer>
      </div>
    </div>
  )
}
